import { Fragment } from "react";
import {
    AppBar,
    IconButton,
    Icon,
    Toolbar,
    Typography,
    Tooltip,
    LinearProgress
  } from "@material-ui/core";

  import {useSelector} from 'react-redux'

const ZappBar = (props) => {
  const fascia = useSelector((state)=>state.fascia.value)
  return (
    <Fragment>
      {!props.onLine ? <LinearProgress color="secondary" /> : null}
      <AppBar position="fixed">
        <Toolbar>
          <Typography
            variant="h6"
            id="logged_in_user"
            component="div"
            sx={{ flexGrow: 1 }}
          >
            {fascia}
          </Typography>

          <div style={{ marginLeft: "auto" } /* right align icons*/}>
            {props.onLine ? (
              <Tooltip title={"Reload List"}>
                <IconButton
                  id="reload_button"
                  size="medium"
                  color="inherit"
                  onClick={() => props.setDialogReloadOpen(true)}
                >
                  <Icon>replay</Icon>
                </IconButton>
              </Tooltip>
            ) : null}
            <Tooltip title={"Sign Out"}>
              <IconButton
                id="sign_out_button"
                size="medium"
                color="inherit"
                onClick={() => props.setDialogAppExitOpen(true)}
              >
                <Icon>exit_to_app</Icon>
              </IconButton>
            </Tooltip>
          </div>
        </Toolbar>
      </AppBar>
      <br></br>
      <br></br>
      <br></br>
    </Fragment>
  );
};
export default ZappBar;
